/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import { FC, Fragment, useEffect, useMemo, useState } from 'react';
import { spaceRowContainer } from '../../../styles';
import { IDailyViewProps } from '../../../types';
import { DayToDropHorizontal } from './DayToDropHorizontal';
import { HorizontalCurrentTimeLine } from './HorizontalCurrentTimeLine';
import { useResources } from '../../../hooks/useResources';
// import { useMiddlewareContext } from "../../../hooks/useMiddlewareContext";

export const DailyViewHorizontal: FC<IDailyViewProps> = ({
	EventComponent,
	onAddNewSlotClick,
	isModeChanged,
	isLoading,
	currentDate,
	resourceGroups,
}) => {
	const { resources } = useResources({ resourceGroups });

	return (
		<Fragment>
			{resources.map((resource, index) => {
				const hiddenEvents = false;

				if (resource.children.length === 0) {
					return (
						<div
							key={`DailyViewHorizontal-horizontal-${resource.id}`}
							css={spaceRowContainer}
							data-aid="DailyViewHorizontal-horizontal"
						>
							<DayToDropHorizontal
								key={`DailyViewHorizontal-${resource.id}`}
								id={String(resource.id)}
								EventComponent={EventComponent}
								onAddNewSlotClick={onAddNewSlotClick}
								hiddenEvents={hiddenEvents}
								isModeChanged={isModeChanged}
								currentDate={currentDate}
								isLoading={isLoading}
								activityTimes={resource.activityTimes}
							/>
						</div>
					);
				} else {
					return (
						<div key={`DailyViewHorizontal-horizontal-${resource.id}`} css={spaceRowContainer}>
							{resource.children.map(child => {
								return (
									<DayToDropHorizontal
										key={`DailyViewHorizontal-${child.id}`}
										id={String(child.id)}
										EventComponent={EventComponent}
										onAddNewSlotClick={onAddNewSlotClick}
										hiddenEvents={hiddenEvents}
										isModeChanged={isModeChanged}
										currentDate={currentDate}
										isLoading={isLoading}
										activityTimes={child.activityTimes}
									/>
								);
							})}
						</div>
					);
				}
			})}
			<HorizontalCurrentTimeLine />
		</Fragment>
	);
};
